import Vue from 'vue'
import Router from 'vue-router'
import WorkerDetails from '../components/evaluate/workerDetails.vue'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
console.log('Router.prototype.push',location)
return originalPush.call(this, location).catch(err => err)

}
const index = () => import('../components/index')
const home = () => import('../components/home/home')//首页
const market = () => import('../components/market/list')//卖场
const designer = () => import('../components/designer/list')//设计师
const designerDetail = () => import('../components/designer/detail')//设计师详情
const upload_case = () => import('../components/designer/upload_case')//设计师上传案例
const store = () => import('../components/store/list')//材料商
const storeDetail = () => import('../components/store/detail')//材料商详情
const project = () => import('../components/project/list')//项目经理
const projectDetail = () => import('../components/project/detail')//项目经理详情
const blog = () => import('../components/blog/list')//项目经理
const blogDetail = () => import('../components/blog/detail')//项目经理详情
const search = () => import('../components/search/search')//搜索
const searchhistory = () => import('../components/search/history')//搜索记录
const searchList = () => import('../components/search/list')//搜索结果列表
const caseList = () => import('../components/case/list')//案例列表
const caseDetail = () => import('../components/case/detail')//案例详情
const decorationco = () => import('../components/decoration/list')//装修公司列表
const decorationcoDetail = () => import('../components/decoration/detail')//装修公司详情
const priceData = () => import('../components/decoration/pricedata') //市场行情
const mine = () => import('../components/mine/cell')//我的
const identity = () => import('../components/mine/identity')//自主申报
const text = () => import('../components/page/text')//文章

const logCase = () => import('../components/mine/log/case')//案例列表
const logDesigner = () => import('../components/mine/log/designer')//设计师
const logCompany = () => import('../components/mine/log/company')//装修公司列表
const logStore = () => import('../components/mine/log/store')//材料商

const logList = () => import('../components/mine/log/lists')//整合列表

const investigation = () => import('../components/investigation/investigation')//需求调研表
const investigation1 = () => import('../components/investigation/investigation1')//需求调研表
const investigation2 = () => import('../components/investigation/investigation2')//需求调研表
const investigation5 = () => import('../components/investigation/investigation_cont')//需求调研表
const investigation_log = () => import('../components/investigation/investigation_log')//需求调研表
const investigation_detail = () => import('../components/investigation/investigation_detail')//需求调研表
const netflow = () => import('../components/investigation/netflow')//业主流量池

const process = () => import('../components/process/process')//流程页
const processDetails = () => import('../components/process/process_details')//流程页详情

const userinfo = () => import('../components/mine/userinfo') //用户信息
const userCase = () => import('../components/mine/case/case') //用户作品
const caseAdd = () => import('../components/mine/case/case-add') //添加作品

const complain = () => import('../components/complain/list') //投诉质检
const complainForm = () => import('../components/complain/complain-form') //投诉质检
const complainFormOK = () => import('../components/complain/complainokform') //投诉质检
const subsidy = () => import('../components/subsidy/index') //家电家装
const goodsOrder = () => import('../components/goods/order') //	商品订单 
const goodsInfo = () => import('../components/goods/info') // 商品信息

const budget = () => import('../components/decoration/budget') //装修查询
const budget2 = () => import('../components/decoration/budget2') //预算查询
const commatch = () => import('../components/decoration/commatch') //装修报价
const designfree = () => import('../components/decoration/designfree') //免费设计
const merchantRegister = () => import('../components/form/merchantRegister') //装企入驻
const merchantResult = () => import('../components/form/merchantResult') //装企入驻-提交成功
const submitok = () => import('../components/decoration/submitok') //提交成功
const cate = () => import('../components/encyclopedia/Cate') //装修百科
const qrcode = () => import('../components/mine/qrcode') //关注公众号
const message = () => import('../components/message/list') //消息
const messagedetail = () => import('../components/message/detail') //消息
const myprofile = () => import('../components/mine/myprofile') //个人信息
const uplogo = () => import('../components/mine/uplogo') //图像裁剪

const rate = () => import('../components/mine/rate') //装修贷利率
const rate_detail = () => import('../components/mine/rate_detail') //装修贷利率详情
const interest = () => import('../components/mine/interest') //装修分期
const interest_detail = () => import('../components/mine/interest_detail') //装修分期详情
const bind_admin = () => import('../components/mine/bind_admin') // 绑定后台
const modify = () => import('../components/mine/modify') // 修改后台密码

const intention_detail = () => import('../components/crm/intention_detail') // 意向池详情
const intention_list = () => import('../components/crm/intention_list') // 意向池列表
const assign_detail = () => import('../components/crm/assign_detail') // 派单详情
const assign_list = () => import('../components/crm/assign_list') // 派单列表
const crm_home = () => import('../components/crm/crm_home') // crm主页
const deal_detail = () => import('../components/crm/deal_detail') // 成交详情
const deal_list = () => import('../components/crm/deal_list') // 成交列表
const record_log = () => import('../components/crm/record_log') // 记录日志
const log_list = () => import('../components/crm/log_list') // 日志详情
const add_log = () => import('../components/crm/add_log') // 客户部添加日志

const new_intention_detail = () => import('../components/new_crm/new_intention_detail') // 意向池详情
const new_intention_list = () => import('../components/new_crm/new_intention_list') // 意向池列表
const new_assign_detail = () => import('../components/new_crm/new_assign_detail') // 派单详情
const new_assign_list = () => import('../components/new_crm/new_assign_list') // 派单列表
const new_crm_home = () => import('../components/new_crm/new_crm_home') // crm主页
const new_record_log = () => import('../components/new_crm/new_record_log') // 记录日志
const new_log_list = () => import('../components/new_crm/new_log_list') // 日志详情
const new_add_log = () => import('../components/new_crm/new_add_log') // 客户部添加日志

const show = () => import('../components/dec_im/show') // 农行投流

const city = () => import('../components/search/city') // 城市

const receive = () => import('../components/investigation/receive') // 免费领取

const resultCalc = () => import('../components/calc/result') //计算结果
const indexCalc = () => import('../components/calc/index') //计算首页
const listCalc = () => import('../components/calc/list') //计算列表
const qrcodeCalc = () => import('../components/calc/qrcode.vue') // 客服二维码页面

const decoCalc = () => import('../components/decoCalc/index.vue') // 计算首页2.0
const decoResult = () => import('../components/decoCalc/result.vue') // 计算结果2.0

const companyManageLogin = () => import('../components/companyManage/login.vue') // 公司管理-登录
const companyManageHome = () => import('../components/companyManage/home.vue') // 公司管理-首页
const companyManageInfo = () => import('../components/companyManage/info.vue') // 公司管理-账户信息
const companyManageEditPwd = () => import('../components/companyManage/editPwd.vue') // 公司管理-修改密码
const companyManageAgreement = () => import('../components/companyManage/agreement.vue') // 公司管理-合作协议
const companyManagePrecise = () => import('../components/companyManage/precise.vue') // 公司管理-精准客户
const companyManageAssign = () => import('../components/companyManage/assign.vue') // 公司管理-我的订单
const companyManageAssignLog = () => import('../components/companyManage/assignLog.vue') // 公司管理-跟进日志
const companyManageAssignAppeal = () => import('../components/companyManage/assignAppeal.vue') // 公司管理-申诉
const companyManageDesignerList = () => import('../components/companyManage/designerList.vue') // 公司管理-设计师管理
const companyManageDesignerAdd = () => import('../components/companyManage/designerAdd.vue') // 公司管理-新增设计师
const companyManageSubAccount = () => import('../components/companyManage/subAccount.vue') // 公司管理-子账号列表
const companyManageCaseList = () => import('../components/companyManage/caseList.vue') // 公司管理-案例列表
const companyManageCaseForm = () => import('../components/companyManage/caseForm.vue') // 公司管理-案例表单

const offerIndex = () => import('../components/offer/index.vue') // 装修C端报价

const publishDiary = () => import('../components/diary/publish') // 发布装修案例
const address = () => import('../components/diary/address') // 发布装修案例
const diaryList = () => import('../components/diary/logList') // 发布装修案例
const diaryHome = () => import('../components/diary/home') // 发布装修案例
const ownerHome = () => import('../components/diary/ownerHome') // 业主的家
const homeDetail = () => import('../components/diary/homeDetail') // 问答详情
const homeSave = () => import('../components/diary/homeSave') // 保存家庭信息
const who = () => import('../components/diary/who') // 谁可以看

const evaluateHome = () => import('../components/evaluate/home') // 评价首页
const managerDetails = () => import('../components/evaluate/managerDetails') // 项目经理详情
const designerDetails = () => import('../components/evaluate/designerDetails') // 设计师详情
const designerReview = () => import('../components/evaluate/designerReview') // 设计师评价
const workerReview = () => import('../components/evaluate/workerReview') // 工人评价
const managerReview = () => import('../components/evaluate/managerReview') // 项目经理评价
const companyReview = () => import('../components/evaluate/companyReview') // 装修公司评价

const companyDetails = () => import('../components/evaluate/companyDetails') //装修公司详情
const workerDetails = () => import('../components/evaluate/workerDetails.vue')

const qaa = () => import('../components/evaluate/qaa') //装修问答
const qaaDetails = () => import('../components/evaluate/qaaDetails') //装修问答详情
const quiz = () => import('../components/evaluate/quiz') //提问

const notice = () => import('../components/evaluate/notice.vue') // 消息

const test = () => import('../components/test/test.vue') // 测试

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'index',
      component: index,
      meta:{
        title: '信用平台',
      },
      children:[
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{
            title: '首页',
            requireAuth: true,
            keepAlive: true,
			
          }
        },
        {
          path: '/mine',
          name: 'mine',
          component: mine,
          meta:{
            title: '我的',
            requireAuth: true,
            keepAlive: true
          }
        },
        {
          path: '/case',
          name: 'case',
          component: caseList,
          meta:{
            title: '案例',
            requireAuth: true,
            keepAlive: true
          }
        },
        {
          path: '/decorationco',
          name: 'decorationco',
          component: decorationco,
          meta:{
            title: '装修公司',
            requireAuth: true,
            keepAlive: true
          }
        },  
		
		
        {
          path: '/designer',
          name: 'designer',
          component: designer,
          meta:{
            title: '设计师',
            requireAuth: true,
            keepAlive: true
          }
        },
		{
		  path: '/project',
		  name: 'project',
		  component: project,
		  meta:{
		    title: '项目经理',
		    requireAuth: true,
		    keepAlive: true
		  }
		},{
			path: '/subsidy',
			name: 'subsidy',
			component: subsidy,
			meta:{
			  title: '家电家装',
			  requireAuth: true,
			  keepAlive: true
			}
		  },
		{
		  path: '/blog',
		  name: 'blog',
		  component: blog,
		  meta:{
		    title: '发现',
		    requireAuth: true,
		    keepAlive: true
		  }
		},
        {
          path: '/store',
          name: 'store',
          component: store,
          meta:{
            title: '材料商',
            requireAuth: true,
            keepAlive: true
          }
        }
      ]
    },
	{
		path: '/evaluateHome',
		name: 'evaluateHome',
		component: evaluateHome,
		meta:{
		  title: '首页',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/designerDetails',
		name: 'designerDetails',
		component: designerDetails,
		meta:{
		  title: '设计师详情',
		  requireAuth: true,
		  keepAlive: true
		}
	},
		{
			path: '/designerReview',
			name: 'designerReview',
			component: designerReview,
			meta:{
			  title: '设计师评价',
			  requireAuth: true,
			  keepAlive: true
			}
		},
		{
				path: '/workerReview',
				name: 'workerReview',
				component: workerReview,
				meta:{
				  title: '工人评价',
				  requireAuth: true,
				  keepAlive: true
				}
			},
			{
				path: '/managerReview',
				name: 'managerReview',
				component: managerReview,
				meta:{
				  title: '项目经理评价',
				  requireAuth: true,
				  keepAlive: true
				}
			},
			{
				path: '/companyReview',
				name: 'companyReview',
				component: companyReview,
				meta:{
				  title: '装修公司评价',
				  requireAuth: true,
				  keepAlive: true
				}
			},
			{
				path: '/companyDetails',
		name: 'companyDetails',
		component: companyDetails,
		meta:{
		  title: '装修公司详情',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/workerDetails',
		name: 'workerDetails',
		component: workerDetails,
		meta:{
		  title: '工匠详情',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/qaa',
		name: 'qaa',
		component: qaa,
		meta:{
		  title: '装修问答',
		  requireAuth: true,
		  keepAlive: true
		}
	},{
		path: '/qaaDetails',
		name: 'qaaDetails',
		component: qaaDetails,
		meta:{
		  title: '问答详情',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/quiz',
		name: 'quiz',
		component: quiz,
		meta:{
		  title: '装修提问',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/notice',
		name: 'notice',
		component: notice,
		meta:{
		  title: '消息',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/managerDetails',
		name: 'managerDetails',
		component: managerDetails,
		meta:{
		  title: '项目经理详情',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/indexCalc',
		name: 'indexCalc',
		component: indexCalc,
		meta:{
		  title: '计算首页',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/resultCalc',
		name: 'resultCalc',
		component: resultCalc,
		meta:{
		  title: '计算结果',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/listCalc',
		name: 'listCalc',
		component: listCalc,
		meta:{
		  title: '计算列表',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/decoCalc',
		name: 'decoCalc',
		component: decoCalc,
		meta:{
		  title: '计算首页',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/decoResult',
		name: 'decoResult',
		component: decoResult,
		meta:{
		  title: '计算结果',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/companyManage/login',
		name: 'companyManageLogin',
		component: companyManageLogin,
		meta:{
		  title: '公司管理登录',
		}
	},
	{
		path: '/companyManage/home',
		name: 'companyManageHome',
		component: companyManageHome,
		meta:{
		  title: '公司管理',
		}
	},
	{
		path: '/companyManage/info',
		name: 'companyManageInfo',
		component: companyManageInfo,
		meta:{
		  title: '账户信息',
		}
	},
	{
		path: '/companyManage/editPwd',
		name: 'companyManageEditPwd',
		component: companyManageEditPwd,
		meta:{
		  title: '修改密码',
		}
	},
	{
		path: '/companyManage/agreement',
		name: 'companyManageAgreement',
		component: companyManageAgreement,
		meta:{
		  title: '合作协议',
		}
	},
	{
		path: '/companyManage/precise',
		name: 'companyManagePrecise',
		component: companyManagePrecise,
		meta:{ title: '精准客户' }
	},
	{
		path: '/companyManage/assign',
		name: 'companyManageAssign',
		component: companyManageAssign,
		meta:{ title: '我的订单' }
	},
	{
		path: '/companyManage/assignLog',
		name: 'companyManageAssignLog',
		component: companyManageAssignLog,
		meta:{ title: '跟进日志' }
	},
	{
		path: '/companyManage/assignAppeal',
		name: 'companyManageAssignAppeal',
		component: companyManageAssignAppeal,
		meta:{ title: '申诉' }
	},
	{
		path: '/companyManage/designerList',
		name: 'companyManageDesignerList',
		component: companyManageDesignerList,
		meta:{ title: '设计师管理' }
	},
	{
		path: '/companyManage/designerAdd',
		name: 'companyManageDesignerAdd',
		component: companyManageDesignerAdd,
		meta:{ title: '新增设计师' }
	},
	{
		path: '/companyManage/subAccount',
		name: 'companyManageSubAccount',
		component: companyManageSubAccount,
		meta:{ title: '子账号列表' }
	},
	{
		path: '/companyManage/caseList',
		name: 'companyManageCaseList',
		component: companyManageCaseList,
		meta:{ title: '案例管理' }
	},
	{
		path: '/companyManage/caseForm',
		name: 'companyManageCaseForm',
		component: companyManageCaseForm,
		meta:{ title: '案例表单' }
	},
	{
		path: '/offerIndex',
		name: 'offerIndex',
		component: offerIndex,
		meta:{
		  title: '装修报价',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/publishDiary',
		name: 'publishDiary',
		component: publishDiary,
		meta:{
		  title: '发布装修案例',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/address',
		name: 'address',
		component: address,
		meta:{
		  title: '发布装修案例',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/diaryList',
		name: 'diaryList',
		component: diaryList,
		meta:{
		  title: '发布装修案例',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/diaryHome',
		name: 'diaryHome',
		component: diaryHome,
		meta:{
		  title: '日记',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/ownerHome',
		name: 'ownerHome',
		component: ownerHome,
		meta:{
		  title: '业主的家',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/homeSave',
		name: 'homeSave',
		component: homeSave,
		meta:{
		  title: '保存家庭信息',
		  requireAuth: true,
		  keepAlive: false
		}
	},
	{
		path: '/who',
		name: 'who',
		component: who,
		meta:{
		  title: '业主的家',
		  requireAuth: true,
		  keepAlive: true
		}
	},
	{
		path: '/homeDetail',
		name: 'homeDetail',
		component: homeDetail,
		meta:{
		  title: '问答详情',
		  requireAuth: true,
		  keepAlive: false
		}
	},
	{
		path: '/qrcodeCalc',
		name: 'qrcodeCalc',
		component: qrcodeCalc,
		meta:{
		  title: '客服二维码',
		  requireAuth: true,
		  keepAlive: true
		}
	},
    {
      path: '/logCase/:type',
      name: 'logCase',
      component: logCase,
      meta:{
        title: '案例',
        requireAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/logCompany/:type',
      name: 'logCompany',
      component: logCompany,
      meta:{
        title: '装修公司',
        requireAuth: true,
        keepAlive: true
      }
    },
	{
		path: '/goodsOrder',
		name: 'goodsOrder',
		component: goodsOrder,
		meta:{
			title: '',
			requireAuth: true,
			keepAlive: true
		}
	},
	{
		path: '/goodsInfo:id',
		name: 'goodsInfo',
		component: goodsInfo,
		meta:{
			title: '',
			requireAuth: true,
			keepAlive: true
		}
	},
    {
      path: '/logDesigner/:type',
      name: 'logDesigner',
      component: logDesigner,
      meta:{
        title: '设计师',
        requireAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/logStore/:type',
      name: 'logStore',
      component: logStore,
      meta:{
        title: '材料商',
        requireAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/logList/:type',
      name: 'logList',
      component: logList,
      meta:{
        title: '整合列表',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/search/detail',
      name: 'search',
      component: search,
      meta:{
        title: '搜索',
        requireAuth: true,
        keepAlive: true
      }
    },
	{
	  path: '/search/history',
	  name: 'searchhistory',
	  component: searchhistory,
	  meta:{
	    title: '搜索记录',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
    {
      path: '/case/detail/:id',
      name: 'case-detail',
      component: caseDetail,
      meta:{
        title: '案例详情',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/decorationco/:id',
      name: 'decorationco-detail',
      component: decorationcoDetail,
      meta:{
        title: '企业详情',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/designer/:id',
      name: 'designer-detail',
      component: designerDetail,
      meta:{
        title: '设计师详情',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/project/:id',
      name: 'project-detail',
      component: projectDetail,
      meta:{
        title: '项目经理详情',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/store/:id',
      name: 'store-detail',
      component: storeDetail,
      meta:{
        title: '材料商详情',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/mine/identity',
      name: 'identity',
      component: identity,
      meta:{
        title: '自主申报',
        requireAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/market/list',
      name: 'market-list',
      component: market,
      meta:{
        title: '卖场信息',
        requireAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/page/text/:type',
      name: 'page-text',
      component: text,
      meta:{
        title: '文章详情',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/investigation',
      name: 'investigation',
      component: investigation,
      meta:{
        title: '需求调研表',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/investigation1',
      name: 'investigation1',
      component: investigation1,
      meta:{
        title: '需求调研表',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/investigation2',
      name: 'investigation2',
      component: investigation2,
      meta:{
        title: '需求调研表',
        requireAuth: true,
        keepAlive: false
      }
    },
	{
		path: '/investigation5',
		name: 'investigation5',
		component: investigation5,
		meta:{
		  title: '需求调研表',
		  requireAuth: true,
		  keepAlive: false
		}
	  },
	  {
		path: '/investigation_log',
		name: 'investigation_log',
		component: investigation_log,
		meta:{
		  title: '需求调研表记录',
		  requireAuth: true,
		  keepAlive: false
		}
	  },
	  {
		path: '/investigation_detail',
		name: 'investigation_detail',
		component: investigation_detail,
		meta:{
		  title: '需求调研表详情',
		  requireAuth: true,
		  keepAlive: false
		}
	  },
	{
	  path: '/netflow',
	  name: 'netflow',
	  component: netflow,
	  meta:{
	    title: '业主流量池',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
    {
      path: '/process',
      name: 'process',
      component: process,
      meta:{
        title: '流程表',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/processDetails/:id',
      name: 'processDetails',
      component: processDetails,
      meta:{
        title: '流程表详情',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/userinfo',
      name: 'userinfo',
      component: userinfo,
      meta:{
        title: '用户信息',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/user/case',
      name: 'user-case',
      component: userCase,
      meta:{
        title: '用户作品',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/user/case-add',
      name: 'user-add',
      component: caseAdd,
      meta:{
        title: '添加作品',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/complain/list',
      name: 'complain',
      component: complain,
      meta:{
        title: '投诉质检',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
		// path: '/complain/complain-form/:user_id/:title/:type',
      path: '/complain/complain-form/:id',
      name: 'complain-form',
      component: complainForm,
      meta:{
        title: '我要投诉质检',
        requireAuth: true,
        keepAlive: false
      }
    },{
      path: '/complain/complainokform',
      name: 'complainokform',
      component: complainFormOK,
      meta:{
        title: '我要投诉质检',
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/decorationco/pricedata',
      name: 'pricedata',
      component: priceData,
      meta:{
        title: '实时装修行情', 
        requireAuth: true,
        keepAlive: false
      }
    },
	{
	  path: '/budget',
	  name: 'budget',
	  component: budget,
	  meta:{
	    title: '预算查询',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/budget2',
	  name: 'budget2',
	  component: budget2,
	  meta:{
	    title: '预算报价',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/qrcode',
	  name: 'qrcode',
	  component: qrcode,
	  meta:{
	    title: '关注公众号',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/commatch',
	  name: 'commatch',
	  component: commatch,
	  meta:{
	    title: '智能匹配',
	    requireAuth: true,
	    keepAlive: true
	  }
	},{
	  path: '/designfree',
	  name: 'designfree',
	  component: designfree,
	  meta:{
	    title: '免费设计',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/merchantRegister',
	  name: 'merchantRegister',
	  component: merchantRegister,
	  meta:{
	    title: '装企入驻',
	    requireAuth: false,
	    keepAlive: false
	  }
	},
	{
	  path: '/merchantResult',
	  name: 'merchantResult',
	  component: merchantResult,
	  meta:{
	    title: '提交成功',
	    requireAuth: false,
	    keepAlive: false
	  }
	},
	{
	  path: '/submitok',
	  name: 'submitok',
	  component: submitok,
	  meta:{
	    title: '提交成功',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/cate',
	  name: 'cate',
	  component: cate,
	  meta:{
	    title: '提交成功',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/message',
	  name: 'message',
	  component: message,
	  meta:{
	    title: '消息',
	    requireAuth: true,
	    keepAlive: true
	  }
	},{
	  path: '/messagedetail',
	  name: 'messagedetail',
	  component: messagedetail,
	  meta:{
	    title: '消息内容',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/myprofile',
	  name: 'myprofile',
	  component: myprofile,
	  meta:{
	    title: '个人信息',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/uplogo',
	  name: 'uplogo',
	  component: uplogo,
	  meta:{
	    title: '裁剪',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/rate',
	  name: 'rate',
	  component: rate,
	  meta:{
	    title: '装修贷利率',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/rate_detail/:money/:month/:rate',
	  name: 'rate_detail',
	  component: rate_detail,
	  meta:{
	    title: '装修贷利率详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/interest',
	  name: 'interest',
	  component: interest,
	  meta:{
	    title: '装修分期',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/interest_detail/:type/:money/:month/:interest',
	  name: 'interest_detail',
	  component: interest_detail,
	  meta:{
	    title: '装修分期详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/intention_detail/:netflow_id',
	  name: 'intention_detail',
	  component: intention_detail,
	  meta:{
	    title: '意向池详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/intention_list',
	  name: 'intention_list',
	  component: intention_list,
	  meta:{
	    title: '意向池列表',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/assign_detail/:intention_id',
	  name: 'assign_detail',
	  component: assign_detail,
	  meta:{
	    title: '派单详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/assign_list',
	  name: 'assign_list',
	  component: assign_list,
	  meta:{
	    title: '派单列表',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/crm_home',
	  name: 'crm_home',
	  component: crm_home,
	  meta:{
	    title: 'crm主页',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/deal_detail/:intention_id',
	  name: 'deal_detail',
	  component: deal_detail,
	  meta:{
	    title: '成交详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/record_log/:intention_id',
	  name: 'record_log',
	  component: record_log,
	  meta:{
	    title: '记录日志',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/log_list/:intention_id',
	  name: 'log_list',
	  component: log_list,
	  meta:{
	    title: '日志详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/add_log/:intention_id',
	  name: 'add_log',
	  component: add_log,
	  meta:{
	    title: '添加日志',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/new_intention_detail/:detail_id',
	  name: 'new_intention_detail',
	  component: new_intention_detail,
	  meta:{
	    title: '意向池详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/new_intention_list',
	  name: 'new_intention_list',
	  component: new_intention_list,
	  meta:{
	    title: '意向池列表',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/new_assign_detail/:rob_id',
	  name: 'new_assign_detail',
	  component: new_assign_detail,
	  meta:{
	    title: '派单详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/new_assign_list',
	  name: 'new_assign_list',
	  component: new_assign_list,
	  meta:{
	    title: '派单列表',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/new_crm_home',
	  name: 'new_crm_home',
	  component: new_crm_home,
	  meta:{
	    title: 'crm主页',
	    requireAuth: true,
	    keepAlive: true
	  }
	},
	{
	  path: '/new_record_log/:rob_id',
	  name: 'new_record_log',
	  component: new_record_log,
	  meta:{
	    title: '记录日志',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/new_log_list/:rob_id',
	  name: 'new_log_list',
	  component: new_log_list,
	  meta:{
	    title: '日志详情',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/new_add_log/:rob_id',
	  name: 'new_add_log',
	  component: new_add_log,
	  meta:{
	    title: '添加日志',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/modify',
	  name: 'modify',
	  component: modify,
	  meta:{
	    title: '修改后台密码',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/bind_admin',
	  name: 'bind_admin',
	  component: bind_admin,
	  meta:{
	    title: '绑定后台',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/modify',
	  name: 'modify',
	  component: modify,
	  meta:{
	    title: '修改后台密码',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/upload_case',
	  name: 'upload_case',
	  component: upload_case,
	  meta:{
	    title: '设计师上传案例',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/show/:cid',
	  name: 'show',
	  component: show,
	  meta:{
	    title: '农行投流',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/city',
	  name: 'city',
	  component: city,
	  meta:{
	    title: '城市',
	    requireAuth: true,
	    keepAlive: false
	  }
	},
	{
	  path: '/receive',
	  name: 'receive',
	  component: receive,
	  meta:{
	    title: '免费领取',
	    requireAuth: false,
	    keepAlive: false
	  }
	},
	{
	  path: '/test',
	  name: 'test',
	  component: test,
	  meta:{
	    title: '测试',
	    requireAuth: false,
	    keepAlive: false
	  }
	},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js